import { noop } from "@common/helpers/function";
import { createContext, useContext } from "react";
import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";

export interface AvatarUploadContextValue {
    isDragActive: boolean;
    inputProps: DropzoneInputProps;
    rootProps: DropzoneRootProps;
    isUploading: boolean;
    open(): void;
}

export const avatarUploadContext = createContext<AvatarUploadContextValue>({
    isDragActive: false,
    inputProps: {},
    rootProps: {},
    isUploading: false,
    open: noop,
});

export const useAvatarUpload = () => {
    const context = useContext(avatarUploadContext);

    if (!context) {
        throw new Error(
            "useAvatarUpload must be used within an AvatarUploadProvider",
        );
    }

    return context;
};
